import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Stack,
  Typography,
  IconButton,
  Button,
  Slide,
} from "@mui/material";
import { Images } from "../../assets/common";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import SkipNextOutlinedIcon from "@mui/icons-material/SkipNextOutlined";
import SkipPreviousOutlinedIcon from "@mui/icons-material/SkipPreviousOutlined";
import LinearProgress from "@mui/material/LinearProgress";
import ShuffleOutlinedIcon from "@mui/icons-material/ShuffleOutlined";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";
import Slider from "@mui/material/Slider";
import PageHeader from "./../../components/PageHeader";

import { display, fullName, getErrorString } from "../../constants/function";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import InfoIcon from "@mui/icons-material/Info";
import "./index.scss";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "./../../components/Loader";
import ApiService from "./../../services/api-service";
import notifier from "./../../components/Notifier";
import TipPopup from "./../../components/TipPopup";
import BottomSheet from "../../components/BottomSheet";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import { useDispatch } from "react-redux";
import { addSongIndexAction } from "./../../action/songs";
export default function MusicPlayer() {
  const dispatch = useDispatch();
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const { state } = useLocation();
  const [index, setIndex] = useState(state["index"] ? state["index"] : 0);
  const songs = useSelector((state) => state.songs);
  const [song, setSong] = useState([]);
  const history = useHistory();
  const [currentTime, setCurrentTime] = useState(0);
  const [track, setTrack] = useState(null);
  const [duration, setDuration] = useState(0);
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [openSheet, setOpenSheet] = React.useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const toggleDrawer = (newOpen, value, id, index) => {
    setOpenSheet(newOpen);
    if (id) {
      setSelectedAlbum(id);
      setSelectedIndex(index);
    }
    if (value && selectedId) makeAction(value);
  };
  const makeAction = (key, id) => {
    switch (key) {
      case "Add to studio":
        setShowPlaylist(true);
        break;
    }
  };
  useEffect(() => {
    songs &&
      songs["songs"].forEach((s, i) => {
        const audio = song;

        audio.push(s);

        setSong([...audio]);
      });
  }, [songs]);
  useEffect(() => {
    //console.log(index);
    return () => {
      song[index].track.pause();
      dispatch(addSongIndexAction(index));
    };
  }, [index]);
  function playPause(i) {
    if (song[i].track.paused) {
      const s = song;
      const t = s[i];
      t.track.play();
      setSong([...s]);
      setTrack({ ...t.track });
      updateTrack();
    } else {
      //   track.pause();
      const s = song;
      const t = s[i];
      t.track.pause();
      stop();
      setSong([...s]);
      setTrack({ ...t });
      updateTrack();
    }
  }
  var myVar;
  const updateTrack = () => {};

  // updating track progress on song change/song play
  useEffect(() => {
    if (song.length > 0) {
      const t = song[index].track;
      // setTrack({ ...t });
      if (t && !t.paused) {
        t.addEventListener("timeupdate", function () {
          const cT = Math.floor(t.currentTime);
          const du = Math.floor(t.duration);
          const prg = Math.floor((cT * 100) / du);
          if (du) {
            setDuration(du);
            setCurrentTime(cT);
            setProgress(prg);
          }
        });
        t.play();
      }
    }
  }, [track]);

  function stop() {
    setInterval(myVar);
  }
  const handleChange = (event, newProgress) => {
    const t = song[index].track;

    const cDu = (duration * newProgress) / 100;
    t.currentTime = cDu;
    setTrack({ ...t });
    setCurrentTime(newProgress);
  };
  console.log("song", song);

  const handleNext = (type) => {
    // let tempSong=song;
    // selectedSong
    const s = song; //temporary song array
    s[index].track.pause();
    setTrack({ ...s[index].track });
    if (type === "next") {
      let i = index + 1;
      setIndex(i);
      s[i].track.play();
      setSong([...s]);
      setTrack({ ...s[i].track });
      updateTrack();
    }

    if (type === "prev") {
      let i = index - 1;
      setIndex(i);
      s[i].track.play();
      setSong([...s]);
      setTrack({ ...s[i].track });
      updateTrack();
    }
  };
  //sent tip to artist
  const handleTip = async (amount) => {
    if (amount) {
      try {
        const payload = {
          id: song[index]["uploader"]["_id"],
          tipAmount: amount,
          type: "artist",
          currency: "siki",
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpen(false);
        song[index].track.play();
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpen(false);
    }
  };
  return (
    <Slide direction="up" in={true} mountOnEnter unmountOnExit>
      <Box sx={{ position: "relative" }}>
        <PageHeader
          title=""
          more={song.length > 0 ? true : false}
          onClick={() => toggleDrawer(true, false, song[index]["_id"], index)}
        />
        {song.length > 0 ? (
          <Box className="__music_player">
            <Box sx={{ position: "relative", padding: "0 18px" }}>
              <Stack>
                <Box sx={{ margin: "auto" }}>
                  <img
                    className="__player_image"
                    src={
                      song[index]["thumbnailImg"]
                        ? song[index]["thumbnailImg"]["filePath"]
                        : Images.rectangle
                    }
                    alt="music"
                  />
                </Box>
                <Stack direction="row" justifyContent="space-between" mt={2}>
                  <Stack direction="column" marginRight="auto">
                    <Typography variant="body1" color="default">
                      {song[index]["title"]}
                    </Typography>
                    <Typography
                      variant="body2"
                      className="_cp"
                      onClick={() => {
                        song[index].track.pause();
                        history.push(
                          `/app/ArtistProfile/${song[index]["uploader"]["_id"]}`
                        );
                      }}
                    >
                      {fullName(song[index]["uploader"])}
                    </Typography>
                  </Stack>
                  <Box>
                    <img
                      onClick={() => {
                        song[index].track.pause();
                        setOpen(true);
                      }}
                      src={Images.tip}
                      alt="tip"
                    />
                  </Box>
                </Stack>
              </Stack>
              <Box sx={{ width: "100%" }}>
                <Slider
                  size="small"
                  value={progress}
                  aria-label="Small"
                  valueLabelDisplay="auto"
                  onChange={handleChange}
                  sx={{
                    padding: 0,
                    height: 5,
                    "& .MuiSlider-thumb": {
                      width: 8,
                      height: 8,
                      transition: "0.3s cubic-bezier(.47,1.64,.41,.8)",
                      "&:before": {
                        boxShadow: "0 2px 12px 0 rgba(0,0,0,0.4)",
                      },

                      "&.Mui-active": {
                        width: 14,
                        height: 14,
                      },
                    },
                    "& .MuiSlider-rail": {
                      opacity: 0.28,
                    },
                  }}
                />
                {/* <LinearProgress variant="determinate" value={currentTime} /> */}
              </Box>
              <Stack
                direction="row"
                justifyContent="flex-end"
                sx={{ marginTop: "12px" }}
              >
                {/* <Typography>{display(currentTime)}</Typography> */}
                <Typography color="primary">
                  -{display(duration - currentTime)}
                </Typography>
              </Stack>
              <Stack direction="column" className="__player_box">
                <Stack direction="row" justifyContent={"space-between"}>
                  {/* <IconButton aria-label="prev song" disabled={song.length < 1}>
                    <ShuffleOutlinedIcon
                      sx={{ fontSize: "30px" }}
                      color="default"
                      className="_cp"
                    />
                  </IconButton> */}

                  <IconButton
                    disabled={index === 0}
                    aria-label="prev song"
                    onClick={() => handleNext("prev")}
                  >
                    <SkipPreviousOutlinedIcon
                      sx={{ fontSize: "30px" }}
                      color="default"
                      className="_cp"
                    />
                  </IconButton>

                  <IconButton
                    aria-label="play song"
                    onClick={() => playPause(index)}
                  >
                    {song[index]["track"] && song[index]["track"].paused ? (
                      <PlayCircleFilledWhiteOutlinedIcon
                        sx={{ fontSize: "60px" }}
                        color="default"
                        className="_cp"
                      />
                    ) : (
                      <PauseCircleOutlinedIcon
                        sx={{ fontSize: "60px" }}
                        color="default"
                        className="_cp"
                      />
                    )}
                  </IconButton>

                  <IconButton
                    disabled={song.length === 0 || index === song.length - 1}
                    aria-label="next song"
                    onClick={() => handleNext("next")}
                  >
                    <SkipNextOutlinedIcon
                      className="_cp"
                      sx={{ fontSize: "30px" }}
                      color="default"
                    />
                  </IconButton>

                  {/* <IconButton
                    aria-label="prev song"
                    disabled={song.length === 0}
                  >
                    <RepeatOutlinedIcon
                      sx={{ fontSize: "30px" }}
                      color="default"
                      className="_cp"
                    />
                  </IconButton> */}
                </Stack>
              </Stack>
            </Box>
          </Box>
        ) : null}
        {/* Bottom navigation */}
        {song.length > 0 ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ backgroundColor: "#222222", height: "66px" }}
          >
            <IconButton onClick={() => history.push("/app/PlayQueue")}>
              <PlaylistPlayIcon color="default" />
            </IconButton>
            {/* <Button
              onClick={() => history.push(`/app/BuyBidInfo/${song["_id"]}`)}
              sx={{ height: "48px" }}
              variant="outlined"
              color="primary"
            >
              <img src={Images.bid} /> &nbsp;Buy/ Bid
            </Button> */}
            <IconButton
              onClick={() =>
                history.push(`/app/SongDetails/${song[index]["_id"]}`)
              }
            >
              <InfoIcon color="default" />
            </IconButton>
          </Stack>
        ) : null}
        {open ? (
          <TipPopup
            artist={fullName(song[index]["uploader"])}
            open={open}
            handleClose={(e) => (!e ? setOpen(false) : handleTip(e))}
          />
        ) : null}
        {loading ? <Loader /> : null}
        <BottomSheet
          open={openSheet}
          actions={["Add to studio"]}
          handleOpen={toggleDrawer}
        />
        {/* Add to studio */}
        {showPlaylist ? (
          <AddMusicToPlaylist
            musicId={selectedId}
            open={showPlaylist}
            handleClose={() => setShowPlaylist(false)}
          />
        ) : null}
      </Box>
    </Slide>
  );
}
